import React from 'react'
import { colors, Divider, LayoutBand, Separator, useContainerWidth } from '@fs/zion-ui'
import { css } from '@linaria/core'
import NavLinks from './NavLinks'
import Legal from './LegalText'
import SocialSection from './SocialSection'

const shadowedSeparatorCss = css`
  height: 8px;
  background-color: ${colors.gray02};
`

export default function FatFooter({
  nonReligiousMode = true,
  canSeeTemple,
  embedded = false,
  external = false,
  ...props
}) {
  const atWidth = useContainerWidth()

  return (
    <footer role="contentinfo" {...props}>
      {!embedded && <div className={shadowedSeparatorCss} />}
      <LayoutBand marginX="lg" marginY="lg">
        <NavLinks nonReligiousMode={nonReligiousMode} canSeeTemple={canSeeTemple} external={external} />
      </LayoutBand>
      <Divider fullWidth />
      <LayoutBand marginY="nano" marginX="lg">
        <Separator size={atWidth({ default: 'sm', sm: 'xs' })} />
        <SocialSection external={external} nonReligiousMode={nonReligiousMode} />
      </LayoutBand>
      {!embedded && (
        <LayoutBand
          color={colors.transparent.gray02}
          marginY={atWidth({ default: 'nano', xs: 'sm', xl: 'nano' })}
          marginX="lg"
          style={{ marginBottom: 'calc(var(--bleedable-bottom) * -1)' }}
        >
          <Legal nonReligiousMode={nonReligiousMode} external={external} />
          <Separator size={atWidth({ default: 'sm', xs: 'hide' })} />
        </LayoutBand>
      )}
    </footer>
  )
}
